/* eslint-disable  xss/no-mixed-html */
/* eslint-disable  vars-on-top */
ACC.address = {
  bindAll: function() {
    $('div.checkout_summary_flow_c .change_address_button').on('click', this.handleChangeAddressButtonClick);
    $('div.checkout_summary_flow_c .change_ultimate_address_button').on('click', this.handleChangeUltimateAddressButtonClick);

    $('.ph-shipping__procceed').on('click', this.validateCheckoutShipping);
    $('#deliveryPhone').on('keyup', this.validatePhoneNumber);

    ACC.address.searchAddr();
  },

  searchAddr: function() {
    $('.ph-searchaddressbox').on('keyup', function() {
      var value = $(this).val().toLowerCase();

      $('.existing_address').filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);

        return true;
      });
    });
  },


  handleChangeAddressButtonClick: function() {
    $(this).parent().find('.ph-deliveryaddress__select').show();
    ACC.address.handleAddressDataLoad();
  },

  handleChangeUltimateAddressButtonClick: function() {
    $(this).parent().find('.ph-deliveryaddress__select').show();
    ACC.address.handleUltimateAddressDataLoad();
  },

  handleAddressDataLoad: function(data) {
    ACC.address.setupDeliveryAddressPopupForm(data);

    var noscrollfix = 'ph-hideoverflow__shippingpopup';

    $.colorbox({
      inline: true,
      href: '#popup_checkout_delivery_address4',
      scrolling: false,
      width: '100%',
      maxWidth: 640,
      overlayClose: false,
      close: '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        $('html').addClass(noscrollfix);
        ACC.common.refreshScreenReaderBuffer();
        $('#colorbox').addClass('ph-shipping-popup');
        $('#cboxContent').addClass('ph-cbox-content');

        if (navigator.appVersion.indexOf('Edge') !== -1) {
          $('.ph-formlabel').addClass('ph-formlabeledge');
        }
      },
      onClosed: function() {
        $('html').removeClass(noscrollfix);
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },

  handleUltimateAddressDataLoad: function() {
    var noscroll = 'ph-hideoverflow__shippingpopup';

    if ($('.ph-selected-consignee').length === 0) {
      $('#ph-noconsignee-tick').removeClass('hidden');
    }

    $.colorbox({
      inline: true,
      href: '#popup_checkout_ultimate_delivery_address',
      scrolling: false,
      width: '100%',
      maxWidth: 640,
      overlayClose: false,
      close: '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('#colorbox').addClass('ph-shipping-popup');
        $('#cboxContent').addClass('ph-cbox-content');
        $('html').addClass(noscroll);

        $('#cboxWrapper').find('.ph-searchaddressboxes').each(function() {
          var inputVal = $(this).val();

          $(this).focus(function() {
            if (this.value === inputVal) {
              this.value = '';
            }
          }).blur(function() {
            if (this.value === '') {
              this.value = inputVal;
            }
          });
        });
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('html').removeClass(noscroll);
      }
    });
  },

  setupDeliveryAddressPopupForm: function() {
    $('.delivery_addresses_list .use_address').on('click', ACC.address.handleSelectExistingAddressClick);
  },


  handleSelectExistingAddressClick: function() {
    ACC.address.handleSelectExitingAddressSuccess();

    return false;
  },

  handleDefaultAddressClick: function() {
    ACC.address.setupDeliveryAddressPopupForm('data');

    return false;
  },

  showSelectedAddress: function(data) {
    if (data !== null) {
      var key = 'deliveryAddress',
          haveDefaultAddress = 'haveDefaultAddress',
          deliveryAddress = {};

      deliveryAddress[key] = data;
      deliveryAddress[haveDefaultAddress] = $('#haveDefaultAddress').val();
      ACC.address.refreshDeliveryAddressSection(deliveryAddress);
    }

    $('.ph-default-address__title').show();
    $('.ph-default-address__info').show();
    $('.ph-selectaddress-button .ph-deliveryaddress__change').show();
    $('.ph-selectaddress-error').hide();
    $('#deliveryAddressOk').val('true');
  },

  handleSelectExitingAddressSuccess: function(data) {
    ACC.address.showSelectedAddress(data);
  },
  bindCreateUpdateAddressForm: function() {
    $('.create_update_address_form').each(function() {
      var options = {
        type: 'POST',
        beforeSubmit: function() {
          $('#checkout_delivery_address').block({
            message: '<img src=\'' + $('.ph-spinnerUrl').text() + '\' />'
          });
          $.colorbox.toggleLoadingOverlay();
        },
        success: function(data) {
          $('#create_update_address_form_container_div').html(data);

          var status = $('.create_update_address_id').attr('status');

          if (status !== null && status.toLowerCase() === 'success') {
            ACC.refresh.getCheckoutCartDataAndRefreshPage();
            parent.$.colorbox.close();
          } else {
            ACC.address.bindCreateUpdateAddressForm();
          }
        },
        complete: function() {
          $('#checkout_delivery_address').unblock();
          $.colorbox.toggleLoadingOverlay();
        }
      };

      $(this).ajaxForm(options);
    });
  },

  refreshDeliveryAddressSection: function() {
    $('div.checkout_summary_flow_c .change_address_button').click(this.handleChangeAddressButtonClick);
  },
  updatecartmessagestatus: function(msgstat) {
    var messageType = 'ph-red-msg';

    if (msgstat !== 'error') {
      messageType = 'ph-orange-msg';
    }

    return messageType;
  },
  messageStatCheck: function(msgkey) {
    var messageval = 'ph-hide-but';

    if (msgkey === 'VPD 020') {
      messageval = 'ph-show-but';
    }

    return messageval;
  },
  enablecartButCheck: function(showlen, blockNonPreferFlag, $placeOrderButton) {
    if (showlen > 0 || blockNonPreferFlag === 'true') {
      $placeOrderButton.addClass('ph-disable-button');
    } else {
      $placeOrderButton.removeClass('ph-disable-button');
    }
  }
};

$(document).ready(function() {
  ACC.address.bindAll();
  ACC.address.showSelectedAddress('data');
  $(document).on('click', '.ph-merch_addr', function() {
    var selectedAddr = $(this).attr('data-addr');

    $('.ph-displayaddr-1').text(selectedAddr);
    $('#merchandiseAddressId').val(selectedAddr);
    $.colorbox.close();
  });

  $('.ph-address_main').not(':first').remove();
});
/* eslint-enable  vars-on-top */
/* eslint-enable  xss/no-mixed-html */
